import { ref } from "vue";
import {
    Resource,
    ResourceState,
    resourceStatePrototype,
    useResourceState,
} from "@/domains/app/resource";

export type Calibre = Resource & {
    label: string;
};

export type CalibreState = ResourceState<Calibre>;

/**
 * Create a calibre state to get data and its mutators
 * @param id Id of the calibre that the state should be related to
 * @returns a calibre state with the data and mutators
 */
export function useCalibre(id?: number): CalibreState {
    const state: CalibreState = {
        data: ref(null),
        apiRoute: "calibres",
        apiErrors: ref(null),
        save: () => resourceStatePrototype.save(state),
        del: () => resourceStatePrototype.del(state),
        init: () =>
            resourceStatePrototype.init(id, state, {
                id: -1,
                label: "",
            }),
    };

    return useResourceState(state);
}
